import React from "react";
import { Badge } from "reactstrap";
import { NeoButton } from "../../../../../components/Common";

const getEnrollmentColumns = ({ formatDate, canceling, onCancel }) => [
    {
        label: "#",
        key: "index",
        style: { width: "40px" },
        render: (row, index, { page, rowsPerPage }) => (
            <span className="text-muted fw-bold">
                {(page - 1) * rowsPerPage + index + 1}
            </span>
        )
    },
    {
        label: "Tipo",
        key: "type",
        render: (row) => {
            let color = "warning";
            let icon = "mdi-star";
            let label = "Experimental";

            if (row.type === 'regular') {
                color = "primary";
                icon = "mdi-school";
                label = "Regular";
            } else if (row.type === 'class-package') {
                color = "info";
                icon = "mdi-ticket-percent";
                label = "Avulsa (Pacote)";
            } else if (row.type === 'waitlist') {
                color = "warning";
                icon = "mdi-clock-outline";
                label = "Lista de Espera";
            }

            return (
                <Badge
                    color={color}
                    className="font-size-12 px-2 py-1"
                    pill
                >
                    <i className={`mdi ${icon} me-1`}></i>
                    {label}
                </Badge>
            );
        }
    },
    {
        label: "Turma",
        key: "idClass",
        render: (row) => {
            const day = row.weekdayLabel || "";
            const time = row.startTime && row.endTime ? `${row.startTime} — ${row.endTime}` : "";
            const prof = row.employeeName ? `Prof. ${row.employeeName.split(" ")[0]}` : "";
            const activity = row.activityName || "";

            if (!day && !time && !prof) {
                return <span className="text-muted">—</span>;
            }

            return (
                <div className="d-flex flex-column gap-1">
                    {activity && <span className="fw-bold text-dark font-size-13">{activity}</span>}
                    <div className="d-flex align-items-center gap-2 text-muted font-size-12">
                        {day && <span><i className="mdi mdi-calendar-outline me-1"></i>{day}</span>}
                        {time && <span><i className="mdi mdi-clock-outline me-1"></i>{time}</span>}
                    </div>
                    {prof && <span className="text-muted font-size-12"><i className="mdi mdi-account-outline me-1"></i>{prof}</span>}
                </div>
            );
        }
    },
    {
        label: "Data",
        key: "startDate",
        render: (row) => {
            if (row.type === 'waitlist') {
                // Para waitlist, exibir data da solicitação
                return formatDate(row.createdAt);
            }
            return formatDate(row.startDate || row.sessionDate);
        }
    },
    {
        label: "Status",
        key: "status",
        render: (row) => {
            if (row.type === 'waitlist' || row.status === 'waiting') {
                return (
                    <Badge
                        color="warning"
                        className="font-size-12 px-2 py-1"
                        pill
                    >
                        <i className="mdi mdi-clock-alert-outline me-1"></i>
                        Aguardando
                    </Badge>
                );
            }

            if (row.status === 'active') {
                return (
                    <Badge color="success" className="font-size-12 px-2 py-1" pill>
                        <i className="mdi mdi-check-circle me-1"></i>Ativa
                    </Badge>
                );
            }

            if (row.status === 'suspended') {
                return (
                    <Badge color="warning" className="font-size-12 px-2 py-1" pill>
                        <i className="mdi mdi-pause-circle me-1"></i>Suspensa
                    </Badge>
                );
            }

            return (
                <Badge color="danger" className="font-size-12 px-2 py-1" pill>
                    <i className="mdi mdi-close-circle me-1"></i>Cancelada
                </Badge>
            );
        }
    },
    {
        label: "Posição",
        key: "position",
        style: { width: "80px" },
        render: (row) => {
            if (row.type !== 'waitlist') {
                return <span className="text-muted">—</span>;
            }
            return (
                <span className="fw-bold text-warning font-size-13">
                    {row.position}ª
                </span>
            );
        }
    },
    {
        label: "Ações",
        key: "actions",
        width: "140px",
        align: "right",
        overflow: "visible",
        render: (row) => {
            // Waitlist: sempre pode cancelar a espera
            if (row.type === 'waitlist') {
                const isCanceling = canceling === row.id;
                return (
                    <NeoButton
                        variant="soft-warning"
                        size="sm"
                        loading={isCanceling}
                        loadingText="Removendo..."
                        icon="mdi-close-circle-outline"
                        disabled={isCanceling}
                        onClick={() => onCancel(row)}
                    >
                        Cancelar Espera
                    </NeoButton>
                );
            }

            if (row.status !== 'active') return null;
            const isCanceling = canceling === row.id;
            return (
                <NeoButton
                    variant="soft-danger"
                    size="sm"
                    loading={isCanceling}
                    loadingText="Cancelando..."
                    icon="mdi-cancel"
                    disabled={isCanceling}
                    onClick={() => onCancel(row)}
                >
                    Cancelar
                </NeoButton>
            );
        }
    }
];

export default getEnrollmentColumns;
